import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EPIC_HEALTH_DEFINITIONS } from './epicsSlice';
import { STORY_HEALTH_DEFINITIONS } from './storiesSlice';

export type HealthWeightMap = Record<string, number>;

interface HealthConfigState {
  epicWeights: HealthWeightMap;
  storyWeights: HealthWeightMap;
}

export const defaultEpicWeights: HealthWeightMap = Object.fromEntries(
  EPIC_HEALTH_DEFINITIONS.map((d) => [d.id, d.score]),
);

export const defaultStoryWeights: HealthWeightMap = Object.fromEntries(
  STORY_HEALTH_DEFINITIONS.map((d) => [d.id, d.score]),
);

const initialState: HealthConfigState = {
  epicWeights: defaultEpicWeights,
  storyWeights: defaultStoryWeights,
};

const healthConfigSlice = createSlice({
  name: 'healthConfig',
  initialState,
  reducers: {
    setEpicWeights: (state, action: PayloadAction<HealthWeightMap>) => {
      state.epicWeights = action.payload;
    },
    setStoryWeights: (state, action: PayloadAction<HealthWeightMap>) => {
      state.storyWeights = action.payload;
    },
  },
});

export const { setEpicWeights, setStoryWeights } = healthConfigSlice.actions;
export default healthConfigSlice.reducer;
